module.exports = __webpack_public_path__ + "img/heart_8_bj.36ac2a68.png";